var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TotemSelect',{ref:"sortingSelect",staticClass:"sorter",attrs:{"options":_vm.orders,"placeholder":this.sortingLabel,"type":"sorting","clearable":false,"reduce":function (ref) {
	var type = ref.type;
	var order = ref.order;

	return ({ type: type, order: order });
},"value":_vm.currentSort},on:{"input":_vm.onSortChange}})}
var staticRenderFns = []

export { render, staticRenderFns }